import { render, staticRenderFns } from "./myLayoutList.vue?vue&type=template&id=8c151fde&scoped=true&"
import script from "./myLayoutList.vue?vue&type=script&lang=js&"
export * from "./myLayoutList.vue?vue&type=script&lang=js&"
import style0 from "./myLayoutList.vue?vue&type=style&index=0&id=8c151fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c151fde",
  null
  
)

export default component.exports